import { BreadCrumbItem } from "./components/breadcrumb-item";
import { HouseIcon } from "./components/house-icon";
import { BackIcon } from "./components/back-icon";
import { Chevron } from "./components/chevron";

export type item = {
  text: string | React.ReactNode;
  href?: string;
  onClick?: () => void;
};

export const Breadcrumb = ({
  items,
  goBack,
  className,
}: {
  items: item[];
  className?: string;
  goBack?: () => void;
}): React.ReactElement<any> => {
  const { href: lastItemHref, text: lastItemText } = (items.findLast((item) => item) || {}) as item;

  return (
    <div className={className}>
      <div className="hidden items-center pb-2 md:flex lg:pb-3">
        {!!goBack ? (
          <BackIcon onCLick={goBack} />
        ) : (
          <>
            <HouseIcon />
            <Chevron />
          </>
        )}
        {items.map(({ href, text, onClick }, index) => (
          <BreadCrumbItem items={items} onClick={onClick} key={index} href={href ?? ""}>
            {text}
          </BreadCrumbItem>
        ))}
      </div>
      <div className="flex items-center pb-2 md:hidden lg:pb-3">
        {!!goBack ? (
          <BackIcon onCLick={goBack} />
        ) : (
          <>
            <HouseIcon /> <Chevron />
          </>
        )}
        ...
        <Chevron />
        {
          <BreadCrumbItem items={items} href={lastItemHref ?? ""}>
            {lastItemText}
          </BreadCrumbItem>
        }
      </div>
    </div>
  );
};
